import React,{useState,useMemo} from "react";
import { ModalRoot, Button, ModalTrigger, ModalTitle, ModalContentButton, Close, ModalContent, TabRoot, TabList, TabTrigger, TabContent, RadioItem, RadioGroup,Input } from "@pmi/nyx-design-system";

// Change Market Model code
function MarketModel({ onClose }) {
    const [searchMarket, setSearchMarket] = useState("");
    const marketData = {
        "markets": [
            { "label": "Market 1", "value": "market-1" },
            { "label": "Market 2", "value": "market-2" },
            { "label": "Market 3", "value": "market-3" },
            { "label": "Market 4", "value": "market-4" },
            { "label": "Market 5", "value": "market-5" },
            { "label": "Market 6", "value": "market-6" },
            { "label": "Market 7", "value": "market-7" },
            { "label": "Market 8", "value": "market-8" },
            { "label": "Market 9", "value": "market-9" },
            { "label": "Market 10", "value": "market-10" },
            { "label": "Market 11", "value": "market-11" },
            { "label": "Market 12", "value": "market-12" },
            { "label": "Market 13", "value": "market-13" },
            { "label": "Market 14", "value": "market-14" },
            { "label": "Market 15", "value": "market-15" },
            { "label": "Market 16", "value": "market-16" },
            { "label": "Market 17", "value": "market-17" },
            { "label": "Market 18", "value": "market-18" },
            { "label": "Market 19", "value": "market-19" },
            { "label": "Market 20", "value": "market-20" }
        ]
    };
    const filteredMarkets = useMemo(() => {
        return marketData.markets.filter(market =>
            market.label.toLowerCase().includes(searchMarket.toLowerCase())
        );
    }, [searchMarket]);
    return (
        <>
            <ModalRoot open onOpenChange={onClose}>
                <ModalContent closeIcon>
                    <ModalTitle>Select market</ModalTitle>
                    <div>Currently selected : <b>Czech Republic</b></div>
                    <div className="mb-3">
                        <TabRoot defaultValue="tab1">
                            <div className="tab-list">
                                <TabList style={{width:"908px", borderBottom:'1px solid  #C7C9C7'}}>
                                    <TabTrigger badgeColor="primary" badgeValue={0} value="tab1">
                                        Region 1
                                    </TabTrigger>
                                    <TabTrigger value="tab2">
                                        Region 2
                                    </TabTrigger>
                                    <TabTrigger value="tab3">
                                        Region 3
                                    </TabTrigger>
                                </TabList>
                            </div>
                         {/* Tab data  */}
                            <TabContent value="tab1" style={{height:'238px',overflow:'auto'}}>
                            <div className="input-wrapper">
                            <Input placeholder="Search market..." starticon="search" className="change_market_input" value={searchMarket} onChange={(e) => setSearchMarket(e.target.value)}  />
                             </div>
                                <RadioGroup dir="ltr" orientation="vertical" size="medium" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "1rem" }}>
                                {filteredMarkets.length > 0 ? ( filteredMarkets.map((market) => (
                                        <RadioItem key={market.value} label={market.label} value={market.value} /> ))
                                ) : (
                                    <p>No results found</p>
                                )}
                                </RadioGroup>
                            </TabContent>

                            <TabContent value="tab2">

                            </TabContent>
                            <TabContent value="tab3">
                                
                            </TabContent>
                        </TabRoot>
                    </div>
                    <ModalContentButton>
                        <Close asChild>
                            <Button outlined style={{border:'none'}}>
                                Cancel
                            </Button>
                        </Close>
                        <Close asChild>
                            <Button>
                                Select Market
                            </Button>
                        </Close>
                    </ModalContentButton>
                </ModalContent>
            </ModalRoot>

        </>
    )
}

export default MarketModel;